import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
import { useCreditDataCard } from "../../../features/credit/lib/useCreditDataCard.js";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import { selectCredit } from "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
const CardPayment = withEnabledComponent(
  memo(function CardPayment2({ isLoading = false, credit, ...props }) {
    useCreditDataCard(credit);
    if (isLoading) {
      return /* @__PURE__ */ jsx(CarCard.PaymentSkeleton, {});
    }
    return /* @__PURE__ */ jsx(CarCard.Payment, { ...props });
  }),
  selectCredit
);
export {
  CardPayment
};
